const SET_HEADERVISIBLE = 'header/SET_HEADERVISIBLE';

export const SetHeaderVisible = (bool) => {
  return {
    type: SET_HEADERVISIBLE,
    headerVisible: bool,
  };
};

const initialState = { headerVisible: true };

export default function header(state = initialState, action) {
  switch (action.type) {
    case SET_HEADERVISIBLE:
      return {
        headerVisible: action.headerVisible,
      };
    default:
      return state;
  }
}
